(function(){

/* ---- CART SIDEBAR BUILD ---- */
function buildSidebar(){
  if(document.getElementById('cart-sidebar')) return;
  var h='<div id="cart-overlay" onclick="StoneCart.close()"></div>'+
    '<div id="cart-sidebar">'+
      '<div class="cs-header">'+
        '<h3>Your Cart <span id="cs-count" class="cs-count-badge">0</span></h3>'+
        '<button class="cs-close" onclick="StoneCart.close()" aria-label="Close">&#10005;</button>'+
      '</div>'+
      '<div id="cs-items" class="cs-items"></div>'+
      '<div class="cs-footer" id="cs-footer" style="display:none">'+
        '<div class="cs-subtotal"><span>Subtotal</span><span id="cs-total"></span></div>'+
        '<p class="cs-note">Taxes and shipping calculated at checkout</p>'+
        '<a href="/checkout" class="cs-checkout-btn">Proceed to Checkout</a>'+
        '<a href="/cart" class="cs-view-cart">View Full Cart</a>'+
      '</div>'+
    '</div>';
  var el=document.createElement('div'); el.innerHTML=h;
  document.body.appendChild(el);
}

function renderItems(cart){
  var el=document.getElementById('cs-items');
  var footer=document.getElementById('cs-footer');
  var badge=document.getElementById('cs-count');
  var totalEl=document.getElementById('cs-total');
  if(!el) return;
  badge.textContent=cart.item_count;
  badge.style.display=cart.item_count>0?'inline-flex':'none';
  document.querySelectorAll('.cart-count').forEach(function(b){
    b.textContent=cart.item_count;
    b.style.display=cart.item_count>0?'flex':'none';
  });
  if(cart.item_count===0){
    el.innerHTML='<div class="cs-empty"><div class="cs-empty-icon">&#128722;</div><p>Your cart is empty</p><a href="/collections/all" onclick="StoneCart.close()" class="cs-shop-link">Start Shopping</a></div>';
    footer.style.display='none'; return;
  }
  footer.style.display='block';
  totalEl.textContent=fmoney(cart.total_price);
  el.innerHTML=cart.items.map(function(item){
    return '<div class="cs-item" data-key="'+item.key+'">'+
      '<div class="cs-item-img">'+(item.image?'<img src="'+item.image+'" alt="'+escHtml(item.product_title)+'">':'<div class="cs-no-img">&#128247;</div>')+'</div>'+
      '<div class="cs-item-info">'+
        '<p class="cs-item-title">'+escHtml(item.product_title)+'</p>'+
        (item.variant_title&&item.variant_title!=='Default Title'?'<p class="cs-item-variant">'+escHtml(item.variant_title)+'</p>':'')+
        '<p class="cs-item-price">'+fmoney(item.price)+'</p>'+
        '<div class="cs-qty">'+
          '<button onclick="StoneCart.updateQty(\''+item.key+'\','+(item.quantity-1)+')">&#8722;</button>'+
          '<span>'+item.quantity+'</span>'+
          '<button onclick="StoneCart.updateQty(\''+item.key+'\','+(item.quantity+1)+')">&#43;</button>'+
        '</div>'+
      '</div>'+
      '<button class="cs-remove" onclick="StoneCart.updateQty(\''+item.key+'\',0)">&#10005;</button>'+
    '</div>';
  }).join('');
}

function fmoney(cents){ return '\u20b9'+(cents/100).toLocaleString('en-IN',{minimumFractionDigits:0,maximumFractionDigits:2}); }
function escHtml(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

function fetchCart(cb){ fetch('/cart.js').then(function(r){return r.json();}).then(cb).catch(console.error); }

window.StoneCart={
  open:function(){
    buildSidebar();
    fetchCart(function(cart){ renderItems(cart); document.getElementById('cart-sidebar').classList.add('open'); document.getElementById('cart-overlay').classList.add('open'); document.body.style.overflow='hidden'; });
  },
  close:function(){
    var sb=document.getElementById('cart-sidebar'); var ov=document.getElementById('cart-overlay');
    if(sb) sb.classList.remove('open'); if(ov) ov.classList.remove('open');
    document.body.style.overflow='';
  },
  updateQty:function(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(renderItems).catch(console.error);
  }
};

/* ---- ADD TO CART — FIX: always use fresh variant id from card ---- */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.add-to-cart-btn');
  if(!btn) return;
  e.preventDefault();
  var card=btn.closest('[data-variant-id]');
  if(!card){ StoneCart.open(); return; }
  var vid=card.getAttribute('data-variant-id');
  if(!vid||vid==='') { StoneCart.open(); return; }
  var orig=btn.textContent;
  btn.textContent='Adding...'; btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid),quantity:1})})
    .then(function(r){
      if(!r.ok) return r.json().then(function(e){throw e;});
      return r.json();
    })
    .then(function(){
      btn.textContent='Added ✓';
      setTimeout(function(){ btn.textContent=orig; btn.disabled=false; },1500);
      StoneCart.open();
    })
    .catch(function(err){
      console.error('Cart add error:',err);
      btn.textContent=orig; btn.disabled=false;
      alert(err&&err.description?err.description:'Could not add to cart. Please try again.');
    });
});

/* ---- CART ICON ---- */
document.addEventListener('click',function(e){
  var a=e.target.closest('#cart-header-btn, .mobile-cart-link');
  if(!a) return;
  e.preventDefault();
  StoneCart.open();
});

/* ---- STICKY HEADER ---- */
window.addEventListener('scroll',function(){
  var h=document.querySelector('.site-header');
  if(h) h.style.boxShadow=window.scrollY>10?'0 2px 20px rgba(0,0,0,0.08)':'';
});

/* ---- MOBILE MENU ---- */
var mBtn=document.querySelector('.menu-toggle');
if(mBtn) mBtn.addEventListener('click',function(){ var n=document.querySelector('.mobile-nav'); if(n) n.classList.toggle('open'); });

/* ---- HERO SLIDER ---- */
(function(){
  var sl=document.getElementById('heroSlider'); if(!sl) return;
  var slides=sl.querySelectorAll('.slide'), dots=sl.querySelectorAll('.dot'), cur=0, timer;
  function show(n){ slides[cur].classList.remove('active'); dots[cur].classList.remove('active'); cur=(n+slides.length)%slides.length; slides[cur].classList.add('active'); dots[cur].classList.add('active'); }
  window.hsChange=function(d){ clearInterval(timer); show(cur+d); start(); };
  window.hsGo=function(n){ clearInterval(timer); show(n); start(); };
  function start(){ timer=setInterval(function(){ show(cur+1); },5000); }
  start();
})();

/* ---- PRODUCT PAGE THUMBNAILS ---- */
(function(){
  var thumbs=document.querySelectorAll('.pdp-thumb');
  thumbs.forEach(function(th){
    th.addEventListener('click',function(){
      var main=document.getElementById('pdp-main-img');
      if(main){ main.src=th.getAttribute('data-full'); main.style.opacity='0'; setTimeout(function(){ main.style.opacity='1'; },50); }
      thumbs.forEach(function(t){ t.classList.remove('active'); });
      th.classList.add('active');
    });
  });
})();

/* ---- VARIANT SELECTOR ---- */
(function(){
  var pills=document.querySelectorAll('.pdp-variant-pill');
  pills.forEach(function(p){
    p.addEventListener('click',function(){
      var group=p.getAttribute('data-option-name');
      document.querySelectorAll('.pdp-variant-pill[data-option-name="'+group+'"]').forEach(function(x){ x.classList.remove('selected'); });
      p.classList.add('selected');
    });
  });
})();

buildSidebar();

})();
